"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelayerProxyHub__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_connext",
                type: "address",
            },
            {
                internalType: "address",
                name: "_spokeConnector",
                type: "address",
            },
            {
                internalType: "address",
                name: "_gelatoRelayer",
                type: "address",
            },
            {
                internalType: "address",
                name: "_feeCollector",
                type: "address",
            },
            {
                internalType: "address",
                name: "_rootManager",
                type: "address",
            },
            {
                internalType: "address",
                name: "_keep3r",
                type: "address",
            },
            {
                internalType: "address",
                name: "_autonolas",
                type: "address",
            },
            {
                internalType: "uint8",
                name: "_autonolasPriority",
                type: "uint8",
            },
            {
                internalType: "uint256",
                name: "_propagateCooldown",
                type: "uint256",
            },
            {
                internalType: "address[]",
                name: "_hubConnectors",
                type: "address[]",
            },
            {
                internalType: "uint32[]",
                name: "_hubConnectorChains",
                type: "uint32[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "ProposedOwnable__onlyOwner_notOwner",
        type: "error",
    },
    {
        inputs: [],
        name: "ProposedOwnable__onlyProposed_notProposedOwner",
        type: "error",
    },
    {
        inputs: [],
        name: "ProposedOwnable__ownershipDelayElapsed_delayNotElapsed",
        type: "error",
    },
    {
        inputs: [],
        name: "ProposedOwnable__proposeNewOwner_invalidProposal",
        type: "error",
    },
    {
        inputs: [],
        name: "ProposedOwnable__proposeNewOwner_noOwnershipChange",
        type: "error",
    },
    {
        inputs: [],
        name: "ProposedOwnable__renounceOwnership_invalidProposal",
        type: "error",
    },
    {
        inputs: [],
        name: "ProposedOwnable__renounceOwnership_noProposal",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "chain",
                type: "uint32",
            },
            {
                internalType: "bytes32",
                name: "l2Hash",
                type: "bytes32",
            },
        ],
        name: "RelayerProxyHub__processFromRoot_alreadyProcessed",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "chain",
                type: "uint32",
            },
        ],
        name: "RelayerProxyHub__processFromRoot_noHubConnector",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "nextWorkable",
                type: "uint256",
            },
        ],
        name: "RelayerProxyHub__propagateCooledDown_notCooledDown",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_relayer",
                type: "address",
            },
        ],
        name: "RelayerProxy__addRelayer_relayerAdded",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_address",
                type: "address",
            },
        ],
        name: "RelayerProxy__definedAddress_empty",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_sender",
                type: "address",
            },
        ],
        name: "RelayerProxy__isWorkableBySender_notWorkable",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_sender",
                type: "address",
            },
        ],
        name: "RelayerProxy__onlyRelayer_notRelayer",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_relayer",
                type: "address",
            },
        ],
        name: "RelayerProxy__removeRelayer_relayerNotAdded",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_sender",
                type: "address",
            },
        ],
        name: "RelayerProxy__validateAndPayWithCredits_notKeep3r",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "updated",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "previous",
                type: "address",
            },
        ],
        name: "AutonolasChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "updated",
                type: "uint8",
            },
            {
                indexed: false,
                internalType: "uint8",
                name: "previous",
                type: "uint8",
            },
        ],
        name: "AutonolasPriorityChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "updated",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "previous",
                type: "address",
            },
        ],
        name: "ConnextChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "updated",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "previous",
                type: "address",
            },
        ],
        name: "FeeCollectorChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "balance",
                type: "uint256",
            },
        ],
        name: "FundsDeducted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "balance",
                type: "uint256",
            },
        ],
        name: "FundsReceived",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "updated",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "previous",
                type: "address",
            },
        ],
        name: "GelatoRelayerChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "hubConnector",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "oldHubConnector",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint32",
                name: "chain",
                type: "uint32",
            },
        ],
        name: "HubConnectorChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "updated",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "previous",
                type: "address",
            },
        ],
        name: "Keep3rChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "proposedOwner",
                type: "address",
            },
        ],
        name: "OwnershipProposed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "propagateCooldown",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "oldPropagateCooldown",
                type: "uint256",
            },
        ],
        name: "PropagateCooldownChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "relayer",
                type: "address",
            },
        ],
        name: "RelayerAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "relayer",
                type: "address",
            },
        ],
        name: "RelayerRemoved",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "rootManager",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "oldRootManager",
                type: "address",
            },
        ],
        name: "RootManagerChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "updated",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "previous",
                type: "address",
            },
        ],
        name: "SpokeConnectorChanged",
        type: "event",
    },
    {
        inputs: [],
        name: "acceptProposedOwner",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_relayer",
                type: "address",
            },
        ],
        name: "addRelayer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "allowedRelayer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "autonolas",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "autonolasPriority",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "connext",
        outputs: [
            {
                internalType: "contract IConnext",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "delay",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        components: [
                            {
                                internalType: "uint32",
                                name: "originDomain",
                                type: "uint32",
                            },
                            {
                                internalType: "uint32",
                                name: "destinationDomain",
                                type: "uint32",
                            },
                            {
                                internalType: "uint32",
                                name: "canonicalDomain",
                                type: "uint32",
                            },
                            {
                                internalType: "address",
                                name: "to",
                                type: "address",
                            },
                            {
                                internalType: "address",
                                name: "delegate",
                                type: "address",
                            },
                            {
                                internalType: "bool",
                                name: "receiveLocal",
                                type: "bool",
                            },
                            {
                                internalType: "bytes",
                                name: "callData",
                                type: "bytes",
                            },
                            {
                                internalType: "uint256",
                                name: "slippage",
                                type: "uint256",
                            },
                            {
                                internalType: "address",
                                name: "originSender",
                                type: "address",
                            },
                            {
                                internalType: "uint256",
                                name: "bridgedAmt",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "normalizedIn",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "nonce",
                                type: "uint256",
                            },
                            {
                                internalType: "bytes32",
                                name: "canonicalId",
                                type: "bytes32",
                            },
                        ],
                        internalType: "struct TransferInfo",
                        name: "params",
                        type: "tuple",
                    },
                    {
                        internalType: "address[]",
                        name: "routers",
                        type: "address[]",
                    },
                    {
                        internalType: "bytes[]",
                        name: "routerSignatures",
                        type: "bytes[]",
                    },
                    {
                        internalType: "address",
                        name: "sequencer",
                        type: "address",
                    },
                    {
                        internalType: "bytes",
                        name: "sequencerSignature",
                        type: "bytes",
                    },
                ],
                internalType: "struct ExecuteArgs",
                name: "_args",
                type: "tuple",
            },
            {
                internalType: "uint256",
                name: "_fee",
                type: "uint256",
            },
        ],
        name: "execute",
        outputs: [
            {
                internalType: "bytes32",
                name: "transferId",
                type: "bytes32",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "feeCollector",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "gelatoRelayer",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        name: "hubConnectors",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "keep3r",
        outputs: [
            {
                internalType: "contract IKeep3rV2",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lastPropagateAt",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "priorityKeepers",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_encodedData",
                type: "bytes",
            },
            {
                internalType: "uint32",
                name: "_fromChain",
                type: "uint32",
            },
            {
                internalType: "bytes32",
                name: "_l2Hash",
                type: "bytes32",
            },
        ],
        name: "processFromRootKeep3r",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        name: "processedRootMessages",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "_connectors",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "_messageFees",
                type: "uint256[]",
            },
            {
                internalType: "bytes[]",
                name: "_encodedData",
                type: "bytes[]",
            },
            {
                internalType: "uint256",
                name: "_relayerFee",
                type: "uint256",
            },
        ],
        name: "propagate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "propagateCooldown",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "_connectors",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "_messageFees",
                type: "uint256[]",
            },
            {
                internalType: "bytes[]",
                name: "_encodedData",
                type: "bytes[]",
            },
        ],
        name: "propagateKeep3r",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "propagateWorkable",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newlyProposed",
                type: "address",
            },
        ],
        name: "proposeNewOwner",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "proposed",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proposedTimestamp",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "bytes",
                        name: "message",
                        type: "bytes",
                    },
                    {
                        internalType: "bytes32[32]",
                        name: "path",
                        type: "bytes32[32]",
                    },
                    {
                        internalType: "uint256",
                        name: "index",
                        type: "uint256",
                    },
                ],
                internalType: "struct ISpokeConnector.Proof[]",
                name: "_proofs",
                type: "tuple[]",
            },
            {
                internalType: "bytes32",
                name: "_aggregateRoot",
                type: "bytes32",
            },
            {
                internalType: "bytes32[32]",
                name: "_aggregatePath",
                type: "bytes32[32]",
            },
            {
                internalType: "uint256",
                name: "_aggregateIndex",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_fee",
                type: "uint256",
            },
        ],
        name: "proveAndProcess",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_relayer",
                type: "address",
            },
        ],
        name: "removeRelayer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "renounced",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "rootManager",
        outputs: [
            {
                internalType: "contract IRootManager",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_encodedData",
                type: "bytes",
            },
            {
                internalType: "uint256",
                name: "_messageFee",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_relayerFee",
                type: "uint256",
            },
        ],
        name: "send",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_autonolas",
                type: "address",
            },
        ],
        name: "setAutonolas",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "_autonolasPriority",
                type: "uint8",
            },
        ],
        name: "setAutonolasPriority",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_connext",
                type: "address",
            },
        ],
        name: "setConnext",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_feeCollector",
                type: "address",
            },
        ],
        name: "setFeeCollector",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_gelatoRelayer",
                type: "address",
            },
        ],
        name: "setGelatoRelayer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_hubConnector",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "_chain",
                type: "uint32",
            },
        ],
        name: "setHubConnector",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_keep3r",
                type: "address",
            },
        ],
        name: "setKeep3r",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_propagateCooldown",
                type: "uint256",
            },
        ],
        name: "setPropagateCooldown",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_rootManager",
                type: "address",
            },
        ],
        name: "setRootManager",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_spokeConnector",
                type: "address",
            },
        ],
        name: "setSpokeConnector",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "spokeConnector",
        outputs: [
            {
                internalType: "contract ISpokeConnector",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "withdraw",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
const _bytecode = "0x60806040523480156200001157600080fd5b50604051620040c4380380620040c4833981016040819052620000349162000800565b60016003558a8a8a8a8989896200004b3362000144565b6200005687620001a9565b620000618662000212565b6200006c856200027b565b6200007784620002e4565b62000082836200034d565b6200008d82620003b6565b62000098816200041f565b620000a38562000488565b50505050505050620000bb876200052c60201b60201c565b620000c68362000595565b60005b825181101562000132576200011d838281518110620000ec57620000ec62000913565b602002602001015183838151811062000109576200010962000913565b6020026020010151620005d760201b60201c565b80620001298162000929565b915050620000c9565b50505050505050505050505062000951565b600080546040516001600160a01b03808516939216917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e091a3600080546001600160a01b039092166001600160a01b0319928316178155600255600180549091169055565b600754604080516001600160a01b03808516825290921660208301527f87539ad41983c0ecff8f321db8edf4dd9e830593562770bdacdda085b83e3bb2910160405180910390a1600780546001600160a01b0319166001600160a01b0392909216919091179055565b600854604080516001600160a01b03808516825290921660208301527f66948d99d8431a8416af2202bc301823b7cdd87beb9bddaa274aedac0611a5fd910160405180910390a1600880546001600160a01b0319166001600160a01b0392909216919091179055565b600454604080516001600160a01b03808516825290921660208301527f5db4a067a1f787c3269642464a2a1560868b50b0873e7dec83939ae2359f6128910160405180910390a1600480546001600160a01b0319166001600160a01b0392909216919091179055565b600554604080516001600160a01b03808516825290921660208301527f649c5e3d0ed183894196148e193af316452b0037e77d2ff0fef23b7dc722bed0910160405180910390a1600580546001600160a01b0319166001600160a01b0392909216919091179055565b600654604080516001600160a01b03808516825290921660208301527f711d2a81db157c0acede64f080708460163dfaddcd4266c2c609efb458d3e4c0910160405180910390a1600680546001600160a01b0319166001600160a01b0392909216919091179055565b600954604080516001600160a01b03808516825290921660208301527f17da78d98886c3b8819430ab0693a44c32dfa6426a4db4601ce45bc4bc2385ec910160405180910390a1600980546001600160a01b0319166001600160a01b0392909216919091179055565b6009546040805160ff8085168252600160a01b90930490921660208301527f65b4d060a802296de931fb313ab2ca65155e7a26b0ea83e41044f3036d5ac3f3910160405180910390a16009805460ff909216600160a01b0260ff60a01b19909216919091179055565b6001600160a01b0381166000908152600a602052604090205460ff1615620004d257604051633d85ded560e11b81526001600160a01b038216600482015260240160405180910390fd5b6001600160a01b0381166000818152600a6020908152604091829020805460ff1916600117905590519182527f03580ee9f53a62b7cb409a2cb56f9be87747dd15017afc5cef6eef321e4fb2c5910160405180910390a150565b600c54604080516001600160a01b03808516825290921660208301527f3124eaf4f16c6ddd81951200c6d8f65d5800753bef06584bd672c8b22c76b487910160405180910390a1600c80546001600160a01b0319166001600160a01b0392909216919091179055565b600d546040805183815260208101929092527f5d93bbdda0d794fed18c39a7b776dc86cbf6ed443032e6baac71373996b85010910160405180910390a1600d55565b63ffffffff81166000818152601060209081526040918290205482516001600160a01b0387811682529091169181019190915280820192909252517ff3f83f3e1df056d9be522e74b3fe84add98c686289a646ae55708277434240929181900360600190a163ffffffff16600090815260106020526040902080546001600160a01b0319166001600160a01b0392909216919091179055565b80516001600160a01b03811681146200068857600080fd5b919050565b805160ff811681146200068857600080fd5b634e487b7160e01b600052604160045260246000fd5b604051601f8201601f191681016001600160401b0381118282101715620006e057620006e06200069f565b604052919050565b60006001600160401b038211156200070457620007046200069f565b5060051b60200190565b600082601f8301126200072057600080fd5b81516020620007396200073383620006e8565b620006b5565b82815260059290921b840181019181810190868411156200075957600080fd5b8286015b848110156200077f57620007718162000670565b83529183019183016200075d565b509695505050505050565b600082601f8301126200079c57600080fd5b81516020620007af6200073383620006e8565b82815260059290921b84018101918181019086841115620007cf57600080fd5b8286015b848110156200077f57805163ffffffff81168114620007f25760008081fd5b8352918301918301620007d3565b60008060008060008060008060008060006101608c8e0312156200082357600080fd5b6200082e8c62000670565b9a506200083e60208d0162000670565b99506200084e60408d0162000670565b98506200085e60608d0162000670565b97506200086e60808d0162000670565b96506200087e60a08d0162000670565b95506200088e60c08d0162000670565b94506200089e60e08d016200068d565b6101008d01516101208e015191955093506001600160401b03811115620008c457600080fd5b620008d28e828f016200070e565b6101408e015190935090506001600160401b03811115620008f257600080fd5b620009008e828f016200078a565b9150509295989b509295989b9093969950565b634e487b7160e01b600052603260045260246000fd5b6000600182016200094a57634e487b7160e01b600052601160045260246000fd5b5060010190565b61376380620009616000396000f3fe6080604052600436106102555760003560e01c80639c166c0b11610139578063d232c220116100b6578063dd39f00d1161007a578063dd39f00d14610757578063de4b054814610777578063e79457f114610797578063e7dc2098146107b7578063f0a67eba146107cd578063f9aa7645146107ed57600080fd5b8063d232c220146106b8578063d9ef0bee146106d7578063dad837a8146106f7578063db20563514610717578063dbd8848d1461073757600080fd5b8063b1f8100d116100fd578063b1f8100d14610615578063ba6fef6114610635578063c415b95c14610665578063c5b350df14610685578063d1851c921461069a57600080fd5b80639c166c0b146105755780639cadce00146105955780639f645a03146105b5578063a42dce80146105d5578063a91b8fb8146105f557600080fd5b806360f0a5ac116101d2578063715018a611610196578063715018a6146104c257806389099717146104d75780638c976851146104f75780638da5cb5b146105175780638efed127146105355780639a2652db1461055557600080fd5b806360f0a5ac146103fe578063622520bb1461041e578063634c7bb51461046c5780636a42b8f81461048c5780636eba787f146104a257600080fd5b80633ccfd60b116102195780633ccfd60b146103745780633cf52ffb146103895780634cc18e571461039e5780634d6f2013146103be5780635e21966a146103de57600080fd5b80631acde6281461029957806321444433146102e957806327866fb11461030d5780632d484bcc146103225780632f55b98d1461034457600080fd5b3661029457604080513481524760208201527f063d07ee72a7483b8e07ca09054bb686775c5c030f945dde3823a5257a0a93eb910160405180910390a1005b600080fd5b3480156102a557600080fd5b506102d46102b4366004612348565b600f60209081526000928352604080842090915290825290205460ff1681565b60405190151581526020015b60405180910390f35b3480156102f557600080fd5b506102ff600e5481565b6040519081526020016102e0565b34801561031957600080fd5b506102d4610820565b34801561032e57600080fd5b5061034261033d366004612372565b610921565b005b34801561035057600080fd5b506102d461035f3660046123a2565b600a6020526000908152604090205460ff1681565b34801561038057600080fd5b50610342610958565b34801561039557600080fd5b506002546102ff565b3480156103aa57600080fd5b506103426103b93660046123a2565b6109c9565b3480156103ca57600080fd5b506103426103d93660046123a2565b610a39565b3480156103ea57600080fd5b506103426103f93660046123a2565b610aa0565b34801561040a57600080fd5b506103426104193660046123a2565b610b07565b34801561042a57600080fd5b506104546104393660046123c4565b6010602052600090815260409020546001600160a01b031681565b6040516001600160a01b0390911681526020016102e0565b34801561047857600080fd5b50600654610454906001600160a01b031681565b34801561049857600080fd5b5062093a806102ff565b3480156104ae57600080fd5b50600454610454906001600160a01b031681565b3480156104ce57600080fd5b50610342610b6e565b3480156104e357600080fd5b506103426104f23660046123a2565b610c20565b34801561050357600080fd5b5061034261051236600461261f565b610c87565b34801561052357600080fd5b506000546001600160a01b0316610454565b34801561054157600080fd5b506102ff6105503660046126b2565b610e6b565b34801561056157600080fd5b506103426105703660046126ed565b610f33565b34801561058157600080fd5b50600954610454906001600160a01b031681565b3480156105a157600080fd5b50600854610454906001600160a01b031681565b3480156105c157600080fd5b506103426105d03660046123a2565b610fc1565b3480156105e157600080fd5b506103426105f03660046123a2565b611028565b34801561060157600080fd5b50610342610610366004612788565b61108f565b34801561062157600080fd5b506103426106303660046123a2565b6110fc565b34801561064157600080fd5b506102d46106503660046123a2565b600b6020526000908152604090205460ff1681565b34801561067157600080fd5b50600554610454906001600160a01b031681565b34801561069157600080fd5b5061034261119a565b3480156106a657600080fd5b506001546001600160a01b0316610454565b3480156106c457600080fd5b506000546001600160a01b0316156102d4565b3480156106e357600080fd5b506103426106f23660046127bb565b61120a565b34801561070357600080fd5b50610342610712366004612808565b6112e8565b34801561072357600080fd5b50600c54610454906001600160a01b031681565b34801561074357600080fd5b5061034261075236600461282b565b61131c565b34801561076357600080fd5b506103426107723660046123a2565b6114a8565b34801561078357600080fd5b50600754610454906001600160a01b031681565b3480156107a357600080fd5b506103426107b23660046128b3565b61150f565b3480156107c357600080fd5b506102ff600d5481565b3480156107d957600080fd5b506103426107e83660046123a2565b6115c6565b3480156107f957600080fd5b5060095461080e90600160a01b900460ff1681565b60405160ff90911681526020016102e0565b600c546040805163957908d160e01b8152815160009384936001600160a01b039091169263957908d19260048083019392829003018187875af115801561086b573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061088f919061292a565b50905080600c60009054906101000a90046001600160a01b03166001600160a01b0316630165bc816040518163ffffffff1660e01b8152600401602060405180830381865afa1580156108e6573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061090a919061294e565b1415801561091b575061091b61162d565b91505090565b6000546001600160a01b0316331461094c576040516311a8a1bb60e31b815260040160405180910390fd5b61095581611646565b50565b6000546001600160a01b03163314610983576040516311a8a1bb60e31b815260040160405180910390fd5b61098b611688565b4761099633826116e1565b6040805182815247602082015260008051602061370e833981519152910160405180910390a1506109c76001600355565b565b6000546001600160a01b031633146109f4576040516311a8a1bb60e31b815260040160405180910390fd5b806001600160a01b038116610a2c57604051633a930fdf60e01b81526001600160a01b03821660048201526024015b60405180910390fd5b610a35826117fa565b5050565b6000546001600160a01b03163314610a64576040516311a8a1bb60e31b815260040160405180910390fd5b806001600160a01b038116610a9757604051633a930fdf60e01b81526001600160a01b0382166004820152602401610a23565b610a3582611863565b6000546001600160a01b03163314610acb576040516311a8a1bb60e31b815260040160405180910390fd5b806001600160a01b038116610afe57604051633a930fdf60e01b81526001600160a01b0382166004820152602401610a23565b610a35826118cc565b6000546001600160a01b03163314610b32576040516311a8a1bb60e31b815260040160405180910390fd5b806001600160a01b038116610b6557604051633a930fdf60e01b81526001600160a01b0382166004820152602401610a23565b610a3582611935565b6000546001600160a01b03163314610b99576040516311a8a1bb60e31b815260040160405180910390fd5b62093a8060025442610bab919061297d565b11610bc9576040516324e0285f60e21b815260040160405180910390fd5b600254600003610bec57604051630e4b303f60e21b815260040160405180910390fd5b6001546001600160a01b031615610c16576040516323295ef960e01b815260040160405180910390fd5b6109c760006119d1565b6000546001600160a01b03163314610c4b576040516311a8a1bb60e31b815260040160405180910390fd5b806001600160a01b038116610c7e57604051633a930fdf60e01b81526001600160a01b0382166004820152602401610a23565b610a3582611a36565b60095433906001600160a01b03168114801590610caf5750600954600160a01b900460ff1615155b8015610ce05750600954610ccf90600190600160a01b900460ff16612990565b60ff16610cdd600a436129a9565b11155b15610d095760405163cd6ff7a160e01b81526001600160a01b0382166004820152602401610a23565b6006546040516335d2155560e11b81523360048201819052916001600160a01b031690636ba42aaa906024016020604051808303816000875af1158015610d54573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610d7891906129d9565b610da0576040516398eac98560e01b81526001600160a01b0382166004820152602401610a23565b610da8611688565b610db061162d565b610de75742600d54600e54610dc591906129f6565b6040516343f0bc3560e01b815260048101929092526024820152604401610a23565b610df48787878787611a9f565b5042600e55610e036001600355565b6006546040516317fbade560e21b81526001600160a01b03838116600483015290911690635feeb79490602401600060405180830381600087803b158015610e4a57600080fd5b505af1158015610e5e573d6000803e3d6000fd5b5050505050505050505050565b336000908152600a602052604081205460ff16610e9d57604051630981f7d560e21b8152336004820152602401610a23565b610ea5611688565b6007546040516331f1f3e960e11b81526001600160a01b03909116906363e3e7d290610ed5908690600401612b6e565b6020604051808303816000875af1158015610ef4573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610f18919061294e565b9050610f2382611b60565b610f2d6001600355565b92915050565b336000908152600a602052604090205460ff16610f6557604051630981f7d560e21b8152336004820152602401610a23565b610f6d611688565b6000610f7c8787878787611a9f565b6040805182815247602082015291925060008051602061370e833981519152910160405180910390a1610fae82611b60565b50610fb96001600355565b505050505050565b6000546001600160a01b03163314610fec576040516311a8a1bb60e31b815260040160405180910390fd5b806001600160a01b03811661101f57604051633a930fdf60e01b81526001600160a01b0382166004820152602401610a23565b610a3582611bba565b6000546001600160a01b03163314611053576040516311a8a1bb60e31b815260040160405180910390fd5b806001600160a01b03811661108657604051633a930fdf60e01b81526001600160a01b0382166004820152602401610a23565b610a3582611c23565b6000546001600160a01b031633146110ba576040516311a8a1bb60e31b815260040160405180910390fd5b816001600160a01b0381166110ed57604051633a930fdf60e01b81526001600160a01b0382166004820152602401610a23565b6110f78383611c8c565b505050565b6000546001600160a01b03163314611127576040516311a8a1bb60e31b815260040160405180910390fd5b6001546001600160a01b038281169116148015611145575060025415155b15611163576040516311bc066560e11b815260040160405180910390fd5b6000546001600160a01b0380831691160361119157604051634a2fb73f60e11b815260040160405180910390fd5b61095581611d25565b6001546001600160a01b031633146111c5576040516311a7f27160e11b815260040160405180910390fd5b62093a80600254426111d7919061297d565b116111f5576040516324e0285f60e21b815260040160405180910390fd5b6001546109c7906001600160a01b03166119d1565b336000908152600a602052604090205460ff1661123c57604051630981f7d560e21b8152336004820152602401610a23565b611244611688565b600854604051630aec6b9f60e21b81526001600160a01b0390911690632bb1ae7c908490611276908790600401612da7565b6000604051808303818588803b15801561128f57600080fd5b505af11580156112a3573d6000803e3d6000fd5b50506040805186815247602082015260008051602061370e83398151915294500191506112cd9050565b60405180910390a16112de81611b60565b6110f76001600355565b6000546001600160a01b03163314611313576040516311a8a1bb60e31b815260040160405180910390fd5b61095581611d73565b60095433906001600160a01b031681148015906113445750600954600160a01b900460ff1615155b8015611375575060095461136490600190600160a01b900460ff16612990565b60ff16611372600a436129a9565b11155b1561139e5760405163cd6ff7a160e01b81526001600160a01b0382166004820152602401610a23565b6006546040516335d2155560e11b81523360048201819052916001600160a01b031690636ba42aaa906024016020604051808303816000875af11580156113e9573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061140d91906129d9565b611435576040516398eac98560e01b81526001600160a01b0382166004820152602401610a23565b61144186868686611ddc565b6006546040516317fbade560e21b81526001600160a01b03838116600483015290911690635feeb79490602401600060405180830381600087803b15801561148857600080fd5b505af115801561149c573d6000803e3d6000fd5b50505050505050505050565b6000546001600160a01b031633146114d3576040516311a8a1bb60e31b815260040160405180910390fd5b806001600160a01b03811661150657604051633a930fdf60e01b81526001600160a01b0382166004820152602401610a23565b610a358261222d565b336000908152600a602052604090205460ff1661154157604051630981f7d560e21b8152336004820152602401610a23565b611549611688565b60085460405163508a109b60e01b81526001600160a01b039091169063508a109b906115819089908990899089908990600401612dc4565b600060405180830381600087803b15801561159b57600080fd5b505af11580156115af573d6000803e3d6000fd5b505050506115bc81611b60565b610fb96001600355565b6000546001600160a01b031633146115f1576040516311a8a1bb60e31b815260040160405180910390fd5b806001600160a01b03811661162457604051633a930fdf60e01b81526001600160a01b0382166004820152602401610a23565b610a35826122c6565b6000600d54600e5461163f91906129f6565b4211905090565b600d546040805183815260208101929092527f5d93bbdda0d794fed18c39a7b776dc86cbf6ed443032e6baac71373996b85010910160405180910390a1600d55565b6002600354036116da5760405162461bcd60e51b815260206004820152601f60248201527f5265656e7472616e637947756172643a207265656e7472616e742063616c6c006044820152606401610a23565b6002600355565b804710156117315760405162461bcd60e51b815260206004820152601d60248201527f416464726573733a20696e73756666696369656e742062616c616e63650000006044820152606401610a23565b6000826001600160a01b03168260405160006040518083038185875af1925050503d806000811461177e576040519150601f19603f3d011682016040523d82523d6000602084013e611783565b606091505b50509050806110f75760405162461bcd60e51b815260206004820152603a60248201527f416464726573733a20756e61626c6520746f2073656e642076616c75652c207260448201527f6563697069656e74206d617920686176652072657665727465640000000000006064820152608401610a23565b600654604080516001600160a01b03808516825290921660208301527f711d2a81db157c0acede64f080708460163dfaddcd4266c2c609efb458d3e4c0910160405180910390a1600680546001600160a01b0319166001600160a01b0392909216919091179055565b600754604080516001600160a01b03808516825290921660208301527f87539ad41983c0ecff8f321db8edf4dd9e830593562770bdacdda085b83e3bb2910160405180910390a1600780546001600160a01b0319166001600160a01b0392909216919091179055565b600454604080516001600160a01b03808516825290921660208301527f5db4a067a1f787c3269642464a2a1560868b50b0873e7dec83939ae2359f6128910160405180910390a1600480546001600160a01b0319166001600160a01b0392909216919091179055565b6001600160a01b0381166000908152600a602052604090205460ff16611979576040516309fbf0f560e31b81526001600160a01b0382166004820152602401610a23565b6001600160a01b0381166000818152600a6020908152604091829020805460ff1916905590519182527f10e1f7ce9fd7d1b90a66d13a2ab3cb8dd7f29f3f8d520b143b063ccfbab6906b91015b60405180910390a150565b600080546040516001600160a01b03808516939216917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e091a3600080546001600160a01b039092166001600160a01b0319928316178155600255600180549091169055565b600954604080516001600160a01b03808516825290921660208301527f17da78d98886c3b8819430ab0693a44c32dfa6426a4db4601ce45bc4bc2385ec910160405180910390a1600980546001600160a01b0319166001600160a01b0392909216919091179055565b60008085815b818163ffffffff161015611ae75786868263ffffffff16818110611acb57611acb612e86565b9050602002013583611add91906129f6565b9250600101611aa5565b50600c5460405163412e12db60e01b81526001600160a01b039091169063412e12db908490611b22908c908c908c908c908c90600401612ee4565b6000604051808303818588803b158015611b3b57600080fd5b505af1158015611b4f573d6000803e3d6000fd5b50949b9a5050505050505050505050565b6004546001600160a01b03163303611b8d57600554611b88906001600160a01b0316826116e1565b611b97565b611b9733826116e1565b6040805182815247602082015260008051602061370e83398151915291016119c6565b600854604080516001600160a01b03808516825290921660208301527f66948d99d8431a8416af2202bc301823b7cdd87beb9bddaa274aedac0611a5fd910160405180910390a1600880546001600160a01b0319166001600160a01b0392909216919091179055565b600554604080516001600160a01b03808516825290921660208301527f649c5e3d0ed183894196148e193af316452b0037e77d2ff0fef23b7dc722bed0910160405180910390a1600580546001600160a01b0319166001600160a01b0392909216919091179055565b63ffffffff81166000818152601060209081526040918290205482516001600160a01b0387811682529091169181019190915280820192909252517ff3f83f3e1df056d9be522e74b3fe84add98c686289a646ae55708277434240929181900360600190a163ffffffff16600090815260106020526040902080546001600160a01b0319166001600160a01b0392909216919091179055565b42600255600180546001600160a01b0319166001600160a01b0383169081179091556040517f6ab4d119f23076e8ad491bc65ce85f017fb0591dce08755ba8591059cc51737a90600090a250565b6009546040805160ff8085168252600160a01b90930490921660208301527f65b4d060a802296de931fb313ab2ca65155e7a26b0ea83e41044f3036d5ac3f3910160405180910390a16009805460ff909216600160a01b0260ff60a01b19909216919091179055565b63ffffffff82166000908152600f6020908152604080832084845290915290205460ff1615611e2d5760405163307de84960e01b815263ffffffff8316600482015260248101829052604401610a23565b63ffffffff82166000908152601060205260409020546001600160a01b0316611e7157604051637ab6707160e01b815263ffffffff83166004820152602401610a23565b63ffffffff82166000818152600f602090815260408083208584529091529020805460ff1916600117905560641480611eb157508163ffffffff166127d8145b15611f44576000611ec484860186612f78565b63ffffffff8416600090815260106020908152604091829020548351918401519251633f7658fd60e01b81529394506001600160a01b031692633f7658fd92611f109291600401613008565b600060405180830381600087803b158015611f2a57600080fd5b505af1158015611f3e573d6000803e3d6000fd5b50505050505b8163ffffffff1661a4b11480611f6257508163ffffffff1662066eed145b1561200b576000611f7584860186613139565b63ffffffff841660009081526010602090815260409182902054835191840151838501516060860151608087015160a08801519651632750dce960e21b81529798506001600160a01b0390941696639d4373a496611fd7969591600401613228565b600060405180830381600087803b158015611ff157600080fd5b505af1158015612005573d6000803e3d6000fd5b50505050505b8163ffffffff16600a148061202757508163ffffffff166101a4145b156120cb57600061203a8486018661338d565b63ffffffff841660009081526010602090815260409182902054835191840151838501516060860151608087015195516337176da760e11b81529697506001600160a01b0390931695636e2edb4e95612097959491600401613519565b600060405180830381600087803b1580156120b157600080fd5b505af11580156120c5573d6000803e3d6000fd5b50505050505b8163ffffffff1661014414806120e857508163ffffffff16610118145b1561218c5760006120fb848601866135f3565b63ffffffff8416600090815260106020908152604091829020548351918401518385015160608601516080870151955163e92a492f60e01b81529697506001600160a01b039093169563e92a492f956121589594916004016136b8565b600060405180830381600087803b15801561217257600080fd5b505af1158015612186573d6000803e3d6000fd5b50505050505b8163ffffffff16608914806121a957508163ffffffff1662013881145b156122275763ffffffff82166000908152601060205260409081902054905163f953cec760e01b81526001600160a01b039091169063f953cec7906121f490879087906004016136f9565b600060405180830381600087803b15801561220e57600080fd5b505af1158015612222573d6000803e3d6000fd5b505050505b50505050565b6001600160a01b0381166000908152600a602052604090205460ff161561227257604051633d85ded560e11b81526001600160a01b0382166004820152602401610a23565b6001600160a01b0381166000818152600a6020908152604091829020805460ff1916600117905590519182527f03580ee9f53a62b7cb409a2cb56f9be87747dd15017afc5cef6eef321e4fb2c591016119c6565b600c54604080516001600160a01b03808516825290921660208301527f3124eaf4f16c6ddd81951200c6d8f65d5800753bef06584bd672c8b22c76b487910160405180910390a1600c80546001600160a01b0319166001600160a01b0392909216919091179055565b803563ffffffff8116811461234357600080fd5b919050565b6000806040838503121561235b57600080fd5b6123648361232f565b946020939093013593505050565b60006020828403121561238457600080fd5b5035919050565b80356001600160a01b038116811461234357600080fd5b6000602082840312156123b457600080fd5b6123bd8261238b565b9392505050565b6000602082840312156123d657600080fd5b6123bd8261232f565b60008083601f8401126123f157600080fd5b5081356001600160401b0381111561240857600080fd5b6020830191508360208260051b850101111561242357600080fd5b9250929050565b634e487b7160e01b600052604160045260246000fd5b604080519081016001600160401b03811182821017156124625761246261242a565b60405290565b60405160e081016001600160401b03811182821017156124625761246261242a565b60405160c081016001600160401b03811182821017156124625761246261242a565b60405160a081016001600160401b03811182821017156124625761246261242a565b604051601f8201601f191681016001600160401b03811182821017156124f6576124f661242a565b604052919050565b60006001600160401b038211156125175761251761242a565b5060051b60200190565b600082601f83011261253257600080fd5b81356001600160401b0381111561254b5761254b61242a565b61255e601f8201601f19166020016124ce565b81815284602083860101111561257357600080fd5b816020850160208301376000918101602001919091529392505050565b600082601f8301126125a157600080fd5b813560206125b66125b1836124fe565b6124ce565b82815260059290921b840181019181810190868411156125d557600080fd5b8286015b848110156126145780356001600160401b038111156125f85760008081fd5b6126068986838b0101612521565b8452509183019183016125d9565b509695505050505050565b60008060008060006060868803121561263757600080fd5b85356001600160401b038082111561264e57600080fd5b61265a89838a016123df565b9097509550602088013591508082111561267357600080fd5b61267f89838a016123df565b9095509350604088013591508082111561269857600080fd5b506126a588828901612590565b9150509295509295909350565b600080604083850312156126c557600080fd5b82356001600160401b038111156126db57600080fd5b830160a0818603121561236457600080fd5b6000806000806000806080878903121561270657600080fd5b86356001600160401b038082111561271d57600080fd5b6127298a838b016123df565b9098509650602089013591508082111561274257600080fd5b61274e8a838b016123df565b9096509450604089013591508082111561276757600080fd5b5061277489828a01612590565b925050606087013590509295509295509295565b6000806040838503121561279b57600080fd5b6127a48361238b565b91506127b26020840161232f565b90509250929050565b6000806000606084860312156127d057600080fd5b83356001600160401b038111156127e657600080fd5b6127f286828701612521565b9660208601359650604090950135949350505050565b60006020828403121561281a57600080fd5b813560ff811681146123bd57600080fd5b6000806000806060858703121561284157600080fd5b84356001600160401b038082111561285857600080fd5b818701915087601f83011261286c57600080fd5b81358181111561287b57600080fd5b88602082850101111561288d57600080fd5b6020928301965094506128a3918701905061232f565b9396929550929360400135925050565b60008060008060008061048087890312156128cd57600080fd5b86356001600160401b038111156128e357600080fd5b6128ef89828a016123df565b9097509550506020870135935061044087018881111561290e57600080fd5b9598949750929560408101953594610460909101359350915050565b6000806040838503121561293d57600080fd5b505080516020909101519092909150565b60006020828403121561296057600080fd5b5051919050565b634e487b7160e01b600052601160045260246000fd5b81810381811115610f2d57610f2d612967565b60ff8281168282160390811115610f2d57610f2d612967565b6000826129c657634e487b7160e01b600052601260045260246000fd5b500690565b801515811461095557600080fd5b6000602082840312156129eb57600080fd5b81516123bd816129cb565b80820180821115610f2d57610f2d612967565b8035612343816129cb565b6000808335601e19843603018112612a2b57600080fd5b83016020810192503590506001600160401b03811115612a4a57600080fd5b80360382131561242357600080fd5b81835281816020850137506000828201602090810191909152601f909101601f19169091010190565b6000808335601e19843603018112612a9957600080fd5b83016020810192503590506001600160401b03811115612ab857600080fd5b8060051b360382131561242357600080fd5b8183526000602080850194508260005b85811015612b06576001600160a01b03612af38361238b565b1687529582019590820190600101612ada565b509495945050505050565b81835260006020808501808196508560051b810191508460005b87811015612b61578284038952612b428288612a14565b612b4d868284612a59565b9a87019a9550505090840190600101612b2b565b5091979650505050505050565b602081526000823561019e19843603018112612b8957600080fd5b60a060208401528301612bac60c08401612ba28361232f565b63ffffffff169052565b612bb86020820161232f565b63ffffffff1660e0840152612bcf6040820161232f565b610100612be38186018363ffffffff169052565b612bef6060840161238b565b9150610120612c08818701846001600160a01b03169052565b612c146080850161238b565b9250610140612c2d818801856001600160a01b03169052565b612c3960a08601612a09565b9350610160612c4b8189018615159052565b612c5860c0870187612a14565b95506101a061018081818c0152612c746102608c018985612a59565b975060e0890135828c0152612c8a878a0161238b565b6001600160a01b03166101c08c0152948801356101e08b015250509085013561020088015284013561022087015283013561024086015250612ccf6020860186612a82565b9250601f1980868403016040870152612ce9838584612aca565b9350612cf86040880188612a82565b9350915080868503016060870152612d11848484612b11565b9350612d1f6060880161238b565b6001600160a01b03811660808801529250612d3d6080880188612a14565b93509150808685030160a087015250612d57838383612a59565b9695505050505050565b6000815180845260005b81811015612d8757602081850181015186830182015201612d6b565b506000602082860101526020601f19601f83011685010191505092915050565b6020815260006123bd6020830184612d61565b6104008183375050565b6104608082528101859052600061048080830190600588901b8401018883805b8a811015612e5a5786840361047f190185528235368d900361043e19018112612e0b578283fd5b8c01610440612e1a8280612a14565b828852612e2a8389018284612a59565b92505050602061040081840182890137610420928301359690920195909552948501949290920191600101612de4565b5050508092505050846020830152612e756040830185612dba565b826104408301529695505050505050565b634e487b7160e01b600052603260045260246000fd5b600081518084526020808501808196508360051b8101915082860160005b85811015612b61578284038952612ed2848351612d61565b98850198935090840190600101612eba565b6060808252810185905260008660808301825b88811015612f25576001600160a01b03612f108461238b565b16825260209283019290910190600101612ef7565b5083810360208501528581526001600160fb1b03861115612f4557600080fd5b8560051b9150818760208301370182810360209081016040850152612f6c90820185612e9c565b98975050505050505050565b600060208284031215612f8a57600080fd5b81356001600160401b0380821115612fa157600080fd5b9083019060408286031215612fb557600080fd5b612fbd612440565b823582811115612fcc57600080fd5b612fd887828601612521565b825250602083013582811115612fed57600080fd5b612ff987828601612521565b60208301525095945050505050565b60408152600061301b6040830185612d61565b828103602084015261302d8185612d61565b95945050505050565b80356001600160401b038116811461234357600080fd5b600082601f83011261305e57600080fd5b8135602061306e6125b1836124fe565b82815260059290921b8401810191818101908684111561308d57600080fd5b8286015b848110156126145780358352918301918301613091565b600060e082840312156130ba57600080fd5b6130c2612468565b90506130cd8261238b565b81526130db6020830161238b565b602082015260408201356040820152606082013560608201526080820135608082015260a082013560a082015260c08201356001600160401b0381111561312157600080fd5b61312d84828501612521565b60c08301525092915050565b60006020828403121561314b57600080fd5b81356001600160401b038082111561316257600080fd5b9083019060c0828603121561317657600080fd5b61317e61248a565b61318783613036565b815260208301356020820152604083013560408201526060830135828111156131af57600080fd5b6131bb8782860161304d565b6060830152506080830135608082015260a0830135828111156131dd57600080fd5b6131e9878286016130a8565b60a08301525095945050505050565b600081518084526020808501945080840160005b83811015612b065781518752958201959082019060010161320c565b6001600160401b038716815285602082015284604082015260c06060820152600061325660c08301866131f8565b84608084015282810360a084015260018060a01b038085511682528060208601511660208301525060408401516040820152606084015160608201526080840151608082015260a084015160a082015260c084015160e060c08301526132bf60e0830182612d61565b9a9950505050505050505050565b600060a082840312156132df57600080fd5b6132e76124ac565b90508135815260208201356020820152604082013560408201526060820135606082015260808201356001600160401b0381111561332457600080fd5b61333084828501612521565b60808301525092915050565b60006040828403121561334e57600080fd5b613356612440565b90508135815260208201356001600160401b0381111561337557600080fd5b6133818482850161304d565b60208301525092915050565b60006020828403121561339f57600080fd5b81356001600160401b03808211156133b657600080fd5b9083019060a082860312156133ca57600080fd5b6133d26124ac565b6133db8361238b565b81526133e96020840161238b565b602082015260408301358281111561340057600080fd5b61340c87828601612521565b6040830152506060830135606082015260808301358281111561342e57600080fd5b929092019160a0838703121561344357600080fd5b61344b6124ac565b8335815260208401358381111561346157600080fd5b61346d888287016132cd565b60208301525060408401358381111561348557600080fd5b6134918882870161333c565b6040830152506060840135838111156134a957600080fd5b6134b588828701612521565b6060830152506080840135838111156134cd57600080fd5b6134d988828701612521565b6080830152508060808301525080935050505092915050565b80518252600060208201516040602085015261351160408501826131f8565b949350505050565b6001600160a01b0386811682528516602082015260a06040820181905260009061354590830186612d61565b846060840152828103608084015283518152602084015160a06020830152805160a0830152602081015160c0830152604081015160e083015260608101516101008301526080810151905060a06101208301526135a6610140830182612d61565b9050604085015182820360408401526135bf82826134f2565b915050606085015182820360608401526135d98282612d61565b915050608085015182820360808401526132bf8282612d61565b60006020828403121561360557600080fd5b81356001600160401b038082111561361c57600080fd5b9083019060a0828603121561363057600080fd5b6136386124ac565b6136418361232f565b815260208301356020820152604083013561ffff8116811461366257600080fd5b604082015260608301358281111561367957600080fd5b61368587828601612521565b60608301525060808301358281111561369d57600080fd5b6136a98782860161304d565b60808301525095945050505050565b63ffffffff8616815284602082015261ffff8416604082015260a0606082015260006136e760a0830185612d61565b8281036080840152612f6c81856131f8565b602081526000613511602083018486612a5956fe9826a73d0fd7186bda6a15195ac17571869cab151bfe9a8fed3f9407fffe5b18a26469706673582212207184e732153e2116cbe612d10609e08880fb8802985eb42cbfce194d0891c30f64736f6c63430008110033";
const isSuperArgs = (xs) => xs.length > 1;
class RelayerProxyHub__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(_connext, _spokeConnector, _gelatoRelayer, _feeCollector, _rootManager, _keep3r, _autonolas, _autonolasPriority, _propagateCooldown, _hubConnectors, _hubConnectorChains, overrides) {
        return super.deploy(_connext, _spokeConnector, _gelatoRelayer, _feeCollector, _rootManager, _keep3r, _autonolas, _autonolasPriority, _propagateCooldown, _hubConnectors, _hubConnectorChains, overrides || {});
    }
    getDeployTransaction(_connext, _spokeConnector, _gelatoRelayer, _feeCollector, _rootManager, _keep3r, _autonolas, _autonolasPriority, _propagateCooldown, _hubConnectors, _hubConnectorChains, overrides) {
        return super.getDeployTransaction(_connext, _spokeConnector, _gelatoRelayer, _feeCollector, _rootManager, _keep3r, _autonolas, _autonolasPriority, _propagateCooldown, _hubConnectors, _hubConnectorChains, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.RelayerProxyHub__factory = RelayerProxyHub__factory;
RelayerProxyHub__factory.bytecode = _bytecode;
RelayerProxyHub__factory.abi = _abi;
//# sourceMappingURL=RelayerProxyHub__factory.js.map